import React from "react";
import { BaseInput } from "./BaseInput";
import { WidgetProps } from "./models";

export const EmailWidgetComponent = (props: WidgetProps<string | number>) => <BaseInput type="email" {...props} />;

export const EmailWidget = EmailWidgetComponent;
